// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"38ff1468","453":"127be8e2","597":"8963029d","713":"bb3201d5"}[chunkId] + ".chunk.js";
};